export default "__VITE_ASSET__1e12d20a__"